module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.cd061363.svg";